export default {
  event: 'Event',
  tournament: 'Tournament',
  coach: 'Training',
  all: 'All',
  notKnow: 'Not know'
}